export const PRODUCT_COUNT_SET = 'PRODUCT_COUNT_SET';
export const PRODUCT_NOTIFI_SET = 'PRODUCT_NOTIFI_SET';
export const PRODUCT_DEFAULTSETTINGS = 'PRODUCT_DEFAULTSETTINGS';
export const PRODUCT_NOTIFICATION_COUNT_SET = 'PRODUCT_NOTIFICATION_COUNT_SET';